import { Routes } from '@angular/router';
import {OrderBookComponent} from "./shared/components/order-book/order-book.component";
import {AllocationDashboardComponent} from "./shared/components/allocation-dashboard/allocation-dashboard.component";
import {FundOverviewComponent} from "./shared/components/fund-overview/fund-overview.component";
import {RealEstateComponent} from "./shared/components/real-estate/real-estate.component";
import {PortfolioComponent} from "./shared/components/portfolio-details/portfolio-details.components";
import {OrderBlockComponent} from "./shared/components/order-block/order-block.component";
import {FlowEditorComponent} from "./shared/components/work-flow/flow-editor.component";


export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'order-book'
    },
    {
        path: 'work-flow',
        component: FlowEditorComponent,
        title: 'Workflow',
    },
    {
        path: 'allocation-dashboard',
        component: AllocationDashboardComponent,
        title: 'Allocation Dashboard'
    },
    {
        path: 'fund-overview',
        component: FundOverviewComponent,
        title: 'Fund Overview'
    },
    {
        path: 'order-book',
        component: OrderBookComponent,
        title: 'Orderbuch'
    },
    {
        path: 'order-baskets',
        component: OrderBlockComponent,
        title: 'Orderkörbe'
    },
    {
        path: 'portfolio-details',
        component: PortfolioComponent,
        title: 'Portfolio Details'
    },
    {
        path: 'real-estate',
        component: RealEstateComponent,
        title: 'Real Estate'
    },
    {
        path: '**',
        redirectTo: 'order-book'
    }
];
